<template>
  <el-dialog
    class="password-modify-modal"
    width="90%"
    title="修改密码"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <form v-loading="loading" class="respone-form">
      <div>
        <el-input v-model="newPassword" type="password" placeholder="请输入新密码" resize="none" />
      </div>
      <div class="actions">
        <el-button type="primary" size="small" @click="doSubmit">确定</el-button>
        <el-button type="default" size="small" @click="close(false)">取消</el-button>
      </div>
    </form>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import { UpdatePassword } from '../services'
export default {
  name: 'PasswordModifyModal',
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      newPassword: ''
    }
  },
  methods: {
    init () {
      return this.open()
    },
    doSubmit () {
      const regax = new RegExp('\\S{6,}')
      if (regax.test(this.newPassword.trim())) {
        UpdatePassword(this.newPassword).then((resp) => {
          return this.close(true)
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$message.error('请输入至少6位的非空白字符')
      }
    }
  }
}
</script>
<style lang="stylus">
.password-modify-modal
  .el-dialog
    max-width 600px
    .el-dialog__body
      padding-top 10px
    .actions
      margin-top 8px
</style>
